/**
 * THE EON WEAR — Waitlist / Password (Shopify OS 2.0)
 * Gestiona únicamente: el contador y el autoplay del vídeo de fondo.
 * La apertura/cierre del acceso por contraseña (Escape, foco, bloqueo de
 * scroll) la resuelve el custom element nativo <password-modal> (Dawn),
 * ya cargado por layout/password.liquid — no se reimplementa aquí.
 */
(function () {
  'use strict';

  var countdownIntervals = {};

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function renderCountdown(root) {
    var target = new Date(root.getAttribute('data-target')).getTime();
    var endedEl = root.parentElement.querySelector('[data-eon-countdown-ended]');
    var values = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    if (!values.days || !values.hours || !values.minutes || !values.seconds) return;

    var diff = target - Date.now();

    if (diff <= 0) {
      values.days.textContent = '00';
      values.hours.textContent = '00';
      values.minutes.textContent = '00';
      values.seconds.textContent = '00';
      root.hidden = true;
      if (endedEl) endedEl.hidden = false;
      return true;
    }

    var totalSeconds = Math.floor(diff / 1000);
    values.days.textContent = pad(Math.floor(totalSeconds / 86400));
    values.hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
    values.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
    values.seconds.textContent = pad(totalSeconds % 60);
    root.hidden = false;
    if (endedEl) endedEl.hidden = true;
    return false;
  }

  function stopCountdown(sectionId) {
    if (countdownIntervals[sectionId]) {
      clearInterval(countdownIntervals[sectionId]);
      delete countdownIntervals[sectionId];
    }
  }

  function startCountdown(root) {
    var sectionId = root.getAttribute('data-section-id');
    stopCountdown(sectionId);

    var ended = renderCountdown(root);
    if (ended) return;

    countdownIntervals[sectionId] = setInterval(function () {
      if (renderCountdown(root)) stopCountdown(sectionId);
    }, 1000);
  }

  function playVideos(scope) {
    var videos = scope.querySelectorAll('.eon-waitlist__video');
    videos.forEach(function (video) {
      video.muted = true;
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          /* Autoplay bloqueado por el navegador; se reintenta en la
             primera interacción del usuario con la sección. */
        });
      }
    });
  }

  function initSection(scope) {
    var countdownRoot = scope.querySelector('[data-eon-countdown]');
    if (countdownRoot) startCountdown(countdownRoot);
    playVideos(scope);

    if (!scope.dataset.eonWaitlistBound) {
      scope.dataset.eonWaitlistBound = 'true';
      scope.addEventListener(
        'click',
        function () {
          playVideos(scope);
        },
        { once: true }
      );
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.eon-waitlist').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target.querySelector('.eon-waitlist');
    if (scope) initSection(scope);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var countdownRoot = event.target.querySelector('[data-eon-countdown]');
    if (countdownRoot) stopCountdown(countdownRoot.getAttribute('data-section-id'));
  });
})();
